import React,{useState} from 'react'

export default function TextForm(props) {

    const[text,setText]=useState('')

    function changeText(event){
      setText(event.target.value)
   }

    function clearText(){
      setText("")
      props.showAlert("Text is clear","success");
  }

  function handleExtraSpaces(){
    let newText=text.split(/[ ]+/);
    setText(newText.join(" "));
    props.showAlert("Extra space is removed","success");
  }

    function upperCase(){
        setText(text.toUpperCase());
        props.showAlert("Converted text into upperCaser","success");
    }

    function lowerCase(){
        setText(text.toLowerCase());
        props.showAlert("Converted text into lowerCaser","success");
    }

    function handleCopy(){
      var text=document.getElementById("myBox");
      text.select();
      navigator.clipboard.writeText(text.value);
      props.showAlert("Text is copied","success");
    }

    

  return (
    <>
    <div className='container'  style={{color:props.mode==='dark'?'white':'black'}}>
    <h1>{props.heading}</h1>
<div className="mb-3">
  <textarea className="form-control" value={text} onChange={changeText} style={{backgroundColor:props.mode==='dark'?'#193e30':'white',color:props.mode==='dark'?'white':'black'}} placeholder="Enter text here" id="myBox" rows="8"></textarea>
</div>
<button className="btn btn-dark mx-2 my-2" onClick={clearText}>Clear Text</button>
<button className="btn btn-dark mx-2 my-2" onClick={handleCopy}>Copy Text</button>
<button className="btn btn-dark mx-2 my-2" onClick={upperCase}>Convert to upperCase</button>
<button className="btn btn-dark mx-2 my-2" onClick={lowerCase}>Convert to lowerCase</button>
<button className="btn btn-dark mx-2 my-2" onClick={handleExtraSpaces}>Remove Extra Space</button>

    </div>
    <div className="container"   style={{color:props.mode==='dark'?'white':'black', }}>
        <h1>Your text</h1>
        <p>{text.split(" ").filter((element)=>{return element.length!==0}).length} words and {text.length} characters</p>

        <h2>Preview</h2>
        <p>{text}</p>
    </div>
    </>
  )
}
